import axios from "axios";
import {URLs} from "./urls"
import {deleteAssetItem, deleteUserImagesItem} from "../store/reducers/userImagesListSlice";
import {pixabayKey} from "./constants";

let templatesCount = 1;

const readToken= ()=>{
    let authToken = sessionStorage.getItem("auth_token")
    return authToken
}

export const getSheetsFromJSON = async (link) => {
    return new Promise(async (resolve, reject) => {
        let {USER} = URLs;
        let payload = false;
        await axios.get(link)
            .then(response => {
                payload = response.data;
                resolve(payload);
            })
            .catch(err => {
                reject(err)
            })
    })
}
export const getAdminTemplateData = async () => {
    return new Promise(async (resolve, reject) => {
        let {ADMIN_PRODUCT} = URLs;
        let payload = false;
        const token = sessionStorage.getItem("auth_token");
        await axios.get(`${ADMIN_PRODUCT}?page=${templatesCount}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
            .then(response => {
                payload = response.data.results;
                templatesCount++
                resolve(payload);
            })
            .catch(err => {
                reject(err)
            })
    })
}
export const getImagesData = async (_, page) => {
    return new Promise(async (resolve, reject) => {
        let {UPLOAD_FILES} = URLs;
        let payload = false;
        const token = sessionStorage.getItem("auth_token");
        await axios.get(`${UPLOAD_FILES}?page=${page}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
            .then(response => {
                payload = response.data.results;
                resolve(payload);
            })
            .catch(err => {
                reject(err)
            })
    })
}
export const getGlobalAssetsData = async (type, page) => {
    return new Promise(async (resolve, reject) => {
        let {GET_GLOBAL_ASSET} = URLs;
        let payload = false;
        const token = sessionStorage.getItem("auth_token");
        await axios.get(`${GET_GLOBAL_ASSET}?asset_type=${type}&page=${page}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
            .then(response => {
                payload = response.data.results;
                resolve(payload);
            })
            .catch(err => {
                reject(err)
            })
    })
}
export const getAuthUser = async () => {
    return new Promise(async (resolve, reject) => {
        let {USER} = URLs;
        let payload = false;
        const token = sessionStorage.getItem("auth_token");
        await axios.get(USER, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
            .then(response => {
                payload = response.data.details;
                resolve(payload);
            })
            .catch(err => {
                reject(err)
            })
    })
}
export const checkIsAdmin = async (authToken) => {
    return new Promise(async (resolve, reject) => {
        let URL = 'https://auth-prod.api.atlasmemorials.com/Auth/checkAdmin/';
        await axios.get(URL, {
            headers: {
                Authorization: `Bearer ${authToken}`,
            }
        })
            .then(response => {
                const isAdmin = response.data;
                resolve(isAdmin);
            })
            .catch(err => {
                reject(err);
            });
    });
};


export const getTemplateByIdForEdit = async (id) => {
    return new Promise(async (resolve, reject) => {
        const token = sessionStorage.getItem("auth_token");
        await axios.get(`${URLs.USER_PRODUCT}${+id}/`,{
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
            .then((response) => {
                console.log({response: response.data})
                resolve([response.data])
            })
            .catch((error) => {
                console.error('There has been a problem with your fetch operation:', error);
                reject(error)
            });
    })
}

export const getTemplateByIdForCopy = async (id) => {
    return new Promise(async (resolve, reject) => {
        await axios.get(`${URLs.GET_SINGLE_PRODUCT}${+id}/`)
            .then((response) => {
                console.log({response: response.data})
                resolve([response.data])
            })
            .catch((error) => {
                console.error('There has been a problem with your fetch operation:', error);
                reject(error)
            });
    })
}

export const getAdminTemplateByIdForEdit = async (id) => {
    return new Promise(async (resolve, reject) => {
        const token = sessionStorage.getItem("auth_token");
        await axios.get(`${URLs.ADMIN_PRODUCT}${+id}/`,{
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
            .then((response) => {
                console.log({response: response.data})
                resolve([response.data])
            })
            .catch((error) => {
                console.error('There has been a problem with your fetch operation:', error);
                reject(error)
            });
    })
}

export const bgRemover = (file) => new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append('url', file);

    const token = sessionStorage.getItem('auth_token');

    axios.post(URLs.REMOVE_BG, formData, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
        },
    })
        .then((res) => {
            if (res.status === 200) {
                resolve(res.data.data);
            }
        })
        .catch((err) => {
            reject(err);
        });
});

export const shareTemplate = (files, checked, id, shareId) => new Promise((resolve, reject) => {
    const formData = new FormData();
    let arr = []
    for (const key in files) {
        arr.push(files[key])
    }
    const imageUrlJson = JSON.stringify(arr);
    formData.append('imagesUrl', imageUrlJson)
    formData.append('isPrivate', checked)
    formData.append('designId', id)

    const token = sessionStorage.getItem('auth_token');

    if (shareId) {
        axios.put(`${URLs.SHARE_API}${shareId}/`, formData, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        })
            .then((res) => {
                if (res.status === 200) {
                    resolve(res.data);
                }
            })
            .catch((err) => {
                reject(err);
            });
    } else {
        axios.post(URLs.SHARE_API, formData, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        })
            .then((res) => {
                if (res.status === 200) {
                    resolve(res.data);
                }
            })
            .catch((err) => {
                reject(err);
            });
    }
});

export const imageEnhancement = (file) => new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append('url', file);
    formData.append('backGroundEnchant', 'true');

    const token = sessionStorage.getItem('auth_token');

    axios.post(URLs.IMAGE_ENHANCEMENT, formData, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
        },
    })
        .then((res) => {
            if (res.status === 200) {
                resolve(res.data.body);
            }
        })
        .catch((err) => {
            reject(err);
        });
});

export const deleteImage = async (itemId, dispatch) => {
    const token = sessionStorage.getItem('auth_token');
    const formData = new FormData();

    formData.append('id', itemId);

    try {
        const response = await axios.delete(URLs.UPLOAD_FILES, {
            data: formData,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (response.status === 200) {
            dispatch(deleteUserImagesItem(itemId));
        }
    } catch (error) {
        console.log(error);
    }
};

export const deleteAssetsImage = async (type, itemId, dispatch) => {
    const token = sessionStorage.getItem('auth_token');

    try {
        const response = await axios.delete(`${URLs.ADD_GLOBAL_ASSET}${+itemId}/`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (response.status === 204) {
            dispatch(deleteAssetItem({type, itemId}));
        }
    } catch (error) {
        console.log(error);
    }
};

export const getGalleryImageFromPixabay = async (page, perpage, query)=>{
    const url = `https://pixabay.com/api/?key=${pixabayKey}&q=${query}&page=${page}&per_page=${perpage}&safesearch=true`;

    const response = await axios.get(url);

    if(response?.data?.hits)
        return response.data.hits;

    return [];
}
